export default __webpack_public_path__ + "static/media/10.211220b5.jpeg";